// extracted by mini-css-extract-plugin
module.exports = {"register":"Login_register__3aZhy","error":"Login_error__3zL3h"};